<template>
    <div class="help-us-improve">
        <b-form
            class="improve-us-form"
            @submit.prevent.stop="submit()"
            ref="improveform">
            <div
                class="errors"
                v-if="form.error">
                <b-alert
                    v-if="form.email_error"
                    show
                    variant="danger">
                    {{ $t('feedback.you_have_not_provided_a_valid_email_address') }}
                </b-alert>
                <b-alert
                    v-if="form.generic_error"
                    show
                    variant="danger">
                    {{ $t('feedback.check_the_form_you_have_not_filled_in_all_the_fields') }}
                </b-alert>
            </div>

            <b-alert
                variant="info"
                show>
                {{ $t('common.fields_with_an_asterisk_are_mandatory') }}
            </b-alert>

            <b-form-group
                :label="$t('common.name')"
                label-for="name-input-field">
                <b-form-input
                    id="name-input-field"
                    v-model="form.name"
                    type="text"
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                :label="$t('common.email')"
                label-for="email-input-field">
                <b-form-input
                    id="email-input-field"
                    v-model="form.email"
                    type="email"
                    :placeholder="$t('common.email')"
                    @blur="validateEmailformat($event)">
                </b-form-input>
            </b-form-group>

            <b-form-group
                :label="$t('feedback.suggestion')"
                label-for="Feedback-input-field">
                <b-form-textarea
                    class="apprentice-textarea"
                    id="Feedback-input-field"
                    v-model="form.feedback"
                    type="text"
                    :placeholder="$t('feedback.suggestion_and_or_feedback')"
                    rows="3"
                    max-rows="5">
                </b-form-textarea>
            </b-form-group>

            <input
                type="hidden"
                name="_token"
                :value="csrfToken" />

            <b-button
                class="btn-send btn-submit"
                v-if="!hideSubmitButton"
                variant="primary"
                @click="submit">
                {{ $t('feedback.send') }}
            </b-button>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'design-2021-apprentice-help-us-improve-form-component',
    props: {
        hideSubmitButton: {
            required: false,
            default: false,
            type: Boolean,
        },
    },

    data() {
        return {
            form: {
                name: '',
                email: '',
                feedback: '',
                error: false,
                generic_error: false,
                email_error: false,
            },
        };
    },

    mounted() {
        this.form.name = this.$authUser.name;
        this.form.email = this.$authUser.email;
    },

    created() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    },

    methods: {
        async submit() {
            if (this.formHasError()) {
                return;
            }

            const data = {
                name: this.form.name,
                email: this.form.email,
                feedback: this.form.feedback,
            };

            this.alert.saving(
                this.$t('feedback.send_message'),
                this.$t('feedback.your_message_is_being_sent_please_wait'),
            );
            await this.axios.post(this.routes.helpImproveUs(), data).then(
                (response) => {
                    this.formReset();
                    this.alert.success(
                        this.$t('feedback.message_sent'),
                        this.$t('feedback.your_message_is_sent_successfully'),
                    );
                    this.$emit('state', '1');
                },
                (error) => {
                    this.$emit('state', '0');
                },
            );
        },

        validateEmailformat(event) {
            const regEx =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (event.target.value.match(regEx)) {
                this.form.error = false;
                this.form.email_error = false;
            } else {
                this.form.error = true;
                this.form.email_error = true;
            }
        },

        formHasError() {
            this.form.error = !!(this.form.name === '' || this.form.email === '' || this.form.feedback === '');
            this.form.generic_error = this.form.error;
            return this.form.error;
        },

        formReset() {
            this.form.name = '';
            this.form.email = '';
            this.form.feedback = '';
            this.form.error = false;
            this.form.generic_error = false;
            this.form.email_error = false;
        },
    },
};
</script>

<style scoped lang="scss">
.notice {
    font-weight: $font-weight-bold;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.improve-us-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .improve-us-form {
        .btn-submit {
            align-self: flex-end;
        }
    }
}
</style>
